import '@/styled-system/styles/recipes/persistent-search-layout.css';
import { persistentSearchLayout } from '@/styled-system/recipes';

export const {
  searchFrame,
  searchHeader,
  searchLayout,
  mapPanel,
  mapPanelMobileActive,
  mapFallbackContainer,
  mapFallbackText,
  contentPanel,
  contentPanelDesktopBottomInset,
  contentPanelMobileMapActive,
  mobileMapSearchBarOverlay,
  contentPanelChildren,
} = persistentSearchLayout();
